var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckedDisabled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E4E4EB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#E4E4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91085 10.8857C5.62684 10.0631 6.89501 10.0341 7.64787 10.8231L10.3415 13.6459C10.3524 13.6573 10.3705 13.6573 10.3814 13.646L17.1771 6.5625C17.8598 5.85086 19 5.85794 19.6738 6.57801C20.3066 7.25424 20.2903 8.31015 19.6368 8.96646L10.4849 18.1586C10.4158 18.228 10.3043 18.2308 10.2318 18.165L5.06304 13.4731C4.31678 12.7957 4.24915 11.646 4.91085 10.8857Z",
    fill: "#555770"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkedDisabled.33b692f68425d6132e37cc647e356998.svg";